export const getAppUrl = (): string => {
  if (process.env.APP_DOMAIN.startsWith('localhost')) {
    return process.env.APP_DOMAIN;
  }

  return process.env.APP_DOMAIN;
};
